import React, { useMemo, useState } from "react";
import UseContext from "hooks/useContext";
import { SearchIcon } from "assets/icons";
import PerimeterMemberLabel from "pages/profil/perimeters/PerimeterMemberLabel";
import {
    filterMembersByQuery,
    sortMembersByName,
} from "pages/profil/perimeters/perimeterMembers";

const PerimeterMemberPicker = ({ members, selectedIds, onChange }) => {
    const { language } = UseContext();
    const [query, setQuery] = useState("");
    const sortedMembers = useMemo(() => sortMembersByName(members), [members]);
    const visibleMembers = useMemo(
        () => filterMembersByQuery(sortedMembers, query),
        [sortedMembers, query]
    );

    const toggleMember = (id) =>
        onChange(
            selectedIds.includes(id)
                ? selectedIds.filter((selectedId) => selectedId !== id)
                : [...selectedIds, id]
        );

    const emptyMessage =
        members.length === 0
            ? language.getValue("perimeters.form.noAssignableMember")
            : language.getValue("perimeters.form.noSearchResult");

    return (
        <div
            role="group"
            aria-labelledby="perimeter-members-label"
            className="flex flex-col gap-2"
        >
            <span
                id="perimeter-members-label"
                className="text-sm text-gray-700"
            >
                {language.getValue("perimeters.form.membersLabel")}
            </span>
            <div className="relative">
                <span
                    className="pointer-events-none absolute left-3 top-1/2 -translate-y-1/2"
                    aria-hidden="true"
                >
                    <SearchIcon wh={18} color="#6B7280" />
                </span>
                <input
                    type="search"
                    value={query}
                    onChange={(event) => setQuery(event.target.value)}
                    placeholder={language.getValue(
                        "perimeters.form.searchPlaceholder"
                    )}
                    aria-label={language.getValue(
                        "perimeters.form.searchPlaceholder"
                    )}
                    className="h-10 w-full rounded-md border border-gray-300 bg-white pl-10 pr-3 text-sm text-gray-900 placeholder:text-gray-400 focus:border-yellow-500 focus:outline-none"
                />
            </div>
            <div className="max-h-60 overflow-y-auto rounded-lg border border-gray-200">
                {visibleMembers.length === 0 ? (
                    <p className="px-4 py-6 text-center text-sm text-gray-500">
                        {emptyMessage}
                    </p>
                ) : (
                    <ul className="divide-y divide-gray-100">
                        {visibleMembers.map((member) => (
                            <li key={member.id}>
                                <label className="flex cursor-pointer items-center gap-3 px-4 py-3 hover:bg-gray-50">
                                    <input
                                        type="checkbox"
                                        checked={selectedIds.includes(
                                            member.id
                                        )}
                                        onChange={() => toggleMember(member.id)}
                                        className="checkbox-primary shrink-0"
                                    />
                                    <PerimeterMemberLabel member={member} />
                                </label>
                            </li>
                        ))}
                    </ul>
                )}
            </div>
        </div>
    );
};

export default PerimeterMemberPicker;
